module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbYAAAG2AQMAAAApxzEzAAAABlBMVEUAAADa29tWtB6hAAAAAXRSTlMAQObYZgAAAGpJREFUeNrt3MEJACEMRcHAFrL9d2FJFiDo0ZugiBCYOeeVkB99KrH2zdOm073pauz7dTqdTqfT6XQ6nU6n0+nudQAAAAAAAAAAAAAAAAAAh9L8U+p0Op1Op9PpdDqdTqfTpe2y7G3rMncDe93jjMAl6wUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/weixin-bg.png
// module id = 593
// module chunks = 0